import React from 'react';
import { Countdown } from './Countdown';
import { PlanCards } from './PlanCards';
import { Emoji } from './Emoji';
const trust = [{
  emoji: '🔒',
  label: 'Pago 100% seguro'
}, {
  emoji: '⚡',
  label: 'Acceso en 5 minutos'
}, {
  emoji: '🛡️',
  label: 'Garantía 7 días'
}, {
  emoji: '💳',
  label: 'Mercado Pago — Tarjeta — Transferencia'
}];
export function CierreFinal() {
  return <section className="w-full bg-forest-950 py-20" data-id="element-38" data-mp="i9u3s6faz6e7">
      <div className="mx-auto max-w-[680px] px-5 sm:px-8" data-id="element-39" data-mp="ialxtct94w2d">
        <h2 className="text-center font-display text-3xl font-extrabold uppercase leading-[1.08] tracking-tight text-cream sm:text-4xl" data-id="element-40" data-mp="dbixu6s4pg19">
          El precio cierra pronto. No vuelve.
        </h2>

        <div className="mt-8" data-id="element-41" data-mp="n8niu3a8n5gh">
          <Countdown label="El precio cierra en:" data-id="element-42" data-mp="n7luwy84iohc" />
        </div>

        <div className="mt-12" data-id="element-43" data-mp="23mx58rux6k4o">
          <PlanCards data-id="element-44" data-mp="23lvj9scd8d86" />
        </div>

        <ul className="mt-10 flex flex-col items-center gap-3" data-id="element-45" data-mp="23p9kgx9amge1">
          {trust.map(item => <li key={item.label} className="inline-flex items-center gap-2 text-sm text-cream/75" data-id="element-46" data-mp="22d862sbnudk4">
              <Emoji symbol={item.emoji} data-id="element-47" data-mp="27b9p5d936cvl" />
              {item.label}
            </li>)}
        </ul>
      </div>
    </section>;
}